import usePageTitle from '@/hooks/use-page-title';
import { Link, Route, Routes } from "react-router-dom";
import { ChevronRight } from 'lucide-react';
import SelectContract from "@/components/shared/select-contract";
import { useCurrentUser } from '@/hooks/api/use-user';
import ListeDocuments from "@/pages/documents/liste-documents";
import PromoBlocs from '@/pages/home/promo-blocs';
import { HOST_MB } from '@/lib/constants';

const Documents = () => {
    usePageTitle('Mes documents');
    const isEligibleParrainage = useCurrentUser().eligible_parrainage;

    return (
        <div className="w-full">
            <nav className="flex items-center gap-1.5 text-xs sm:text-sm text-muted-foreground mt-4" aria-label="Fil d'Ariane">
                <Link to="/" className="hover:text-foreground transition-colors no-underline">Mon espace</Link>
                <ChevronRight className="w-3 h-3 sm:w-3.5 sm:h-3.5" />
                <Link to="/mes-documents" className="hover:text-foreground transition-colors no-underline">Mes documents</Link>
            </nav>
            <h1 className="text-xl sm:text-2xl font-bold mt-4">Mes documents</h1>

            <div className="mt-4">
            <Routes>
                <Route index element={
                    <SelectContract>
                        <ListeDocuments />
                    </SelectContract>
                } />
            </Routes>
            </div>

            {HOST_MB === 43397 && <div className="mt-6"><PromoBlocs isEligibleParrainage={isEligibleParrainage} /></div>}
        </div>
    );
};

export default Documents;
